<!-- eslint-disable -->
<template>
  <CommonPages id="categoryDetail" :class="['category-detail']" :titlePrefix="categoryDisplayName">
    <div class="categories-container">
      <!-- 顶部标题区域 -->
      <div class="categories-header" :class="[deviceType]">
        <div class="categories-title">Explore Baby Names by {{ categoryDisplayName }}</div>
        <div class="categories-subtitle">Every family's naming journey is unique. Start exploring
          names by {{ categoryDisplayName.toUpperCase() }} to discover options that reflect your
          story, your culture, and your hopes for the future.</div>
      </div>

      <!-- 分类卡片区域 -->
      <div class="categories-cards" :class="[deviceType]">
        <template v-for="(category, index) in displayCategories">
          <div class="category-card" :key="index">
            <div class="card-header">
              <div class="card-dot"></div>
              <div class="card-title">{{ category.title }}</div>
            </div>
            <div class="card-items">
              <div v-for="(item, itemIndex) in category.items" :key="itemIndex" class="card-item"
                :class="{'active': activeItem === item.name, 'colored-bg': categoryType === 'gender'}"
                @click="handleItemClick(item)">
                <div class="item-text">{{ item.name }}</div>
                <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                  class="item-arrow" />
              </div>
            </div>
            <div class="card-footer" @click="viewAllItems(category)">
              <div class="view-all">View All</div>
              <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                class="footer-arrow" />
            </div>
          </div>
          <AdComponent v-if="deviceType === 'mobile' && index === 0" :key="'ads-category-detail-1'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_detail_1"
            ref="ads-category-detail-1" class="ad-width-100 "
            :ads="adsensConfig?.categories_detail_1" :showDebug="showDebug" />
        </template>
      </div>

      <!-- 分页导航 -->
      <div class="pagination-nav" v-if="showPagination">
        <div class="pagination-container">
          <div class="pagination-arrow prev" @click="prevPage">
            <img src="@/assets/default/arrow-right-small_w.svg" alt="previous" class="prev-arrow" />
          </div>
          <div class="pagination-dots">
            <div v-for="index in totalPages" :key="index-1" class="pagination-dot"
              :class="{'active': currentPage === index-1}" @click="currentPage = index-1"></div>
          </div>
          <div class="pagination-arrow next" @click="nextPage">
            <img src="@/assets/default/arrow-right-small_w.svg" alt="next" class="next-arrow" />
          </div>
        </div>
      </div>
    </div>

    <AdComponent :key="'ads-category-detail-2'" v-if="deviceType === 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_detail_2"
      ref="ads-category-detail-2" class="ad-width-100 pc_padding m_padding"
      :ads="adsensConfig?.categories_detail_2" :showDebug="showDebug" />
    <AdComponent :key="'ads-category-detail-1'" v-if="deviceType !== 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_detail_1"
      ref="ads-category-detail-1" class="ad-width-100 pc_padding m_padding"
      :ads="adsensConfig?.categories_detail_1" :showDebug="showDebug" />

    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row" :class="[deviceType]">
          <div class="combination-card-link" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null">
            <div class="combination-card" :class="{'hovered': hoveredCombination === index}">
              <div class="combination-text">
                {{ combo.title }}
              </div>
              <div class="see-more-button">
                <span>See More</span>
                <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                  class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AdComponent :key="'ads-category-detail-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_detail_3"
      ref="ads-category-detail-3" class="ad-width-100 pc_padding m_padding"
      :ads="adsensConfig?.categories_detail_3" :showDebug="showDebug" />

    <section class="search-sec-row" :class="[deviceType]">
      <!-- 搜索过滤区域 -->
      <div class="section-header" :class="[deviceType]">
        <div class="section-title">Search by Filter</div>
      </div>

      <div class="names-filter" :class="[deviceType]">
        <SearchFilter />
      </div>
    </section>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'

// import '@/css/categories.scss';

export default {
  name: 'CategoryDetail',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      activeItem: null,
      currentPage: 0,
      itemsPerPage: 3, // 每页显示3个分类
      hoveredCombination: null,
      categoryData: [],
      combinations: [],
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
      "adsensConfig",
      'showDebug',
      'adPosConfig',
    ]),
    pageTitle () {
      return `Browse by ${this.categoryDisplayName}`;
    },
    pageDescription () {
      const origin = this.domainConfig?.origin || 'Japanese';
      // eslint-disable-next-line max-len
      return `View ${origin} names grouped by ${this.categoryDisplayName}, including popular styles like vintage, modern, cute, and more.`;
    },
    categoryType () {
      return this.$route.params.cate || 'gender';
    },
    categoryDisplayName () {
      const cate = this.categoryType;
      if (!cate) return 'Category';
      return cate.charAt(0).toUpperCase() + cate.slice(1);
    },
    allCategories () {
      return this.categoryData;
    },
    totalPages () {
      const totalCategories = this.allCategories.length;
      return Math.ceil(totalCategories / this.itemsPerPage);
    },
    displayCategories () {
      if (!this.showPagination || this.categoryType === 'gender') {
        // 性别分类不分页，直接显示全部
        return this.allCategories;
      }

      // 分页显示，每页显示itemsPerPage个分类
      const startIndex = this.currentPage * this.itemsPerPage;
      const endIndex = Math.min(startIndex + this.itemsPerPage, this.allCategories.length);
      return this.allCategories.slice(startIndex, endIndex);
    },
    showPagination () {
      // 只有当分类类型是style且总分类数大于每页显示数量时才显示分页
      return (this.categoryType === 'style') &&
        this.allCategories.length > this.itemsPerPage;
    }
  },
  beforeMount () {
    this.fetchCategoryDetails();
    this.fetchCombinations();
  },
  async mounted () {
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
  methods: {
    async fetchCategoryDetails () {
      const origin = this.domainConfig?.origin || '';
      const category = this.categoryDisplayName;
      if (!origin || !category) return;

      try {
        const response = await this.$global.server.postAPI({
          method: 'get',
          params: { origin, category },
          url: '/name/tab',
        });
        if (response.data && response.data.map) {
          const apiData = response.data.map;
          const transformedData = Object.keys(apiData).map(key => ({
            title: key,
            items: apiData[key].map(item => ({
              ...item,
              name: item.name,
              path: `/names/${item.name.toLowerCase().replace(/\s+/g, '-')}/${item.id}`
            }))
          }));
          this.categoryData = transformedData;

          const type = this.$route.query.type;
          if (type && this.showPagination) {
            const categoryIndex = this.allCategories.findIndex(cat => cat.title.toLowerCase() === type.toLowerCase());
            if (categoryIndex !== -1) {
              this.currentPage = Math.floor(categoryIndex / this.itemsPerPage);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching category details:', error);
        this.categoryData = [];
      }
    },
    handleItemClick (item) {
      this.activeItem = item.name;
      this.$router.push(item.path);
    },
    viewAllItems (category) {
      this.$router.push(`/categories/${this.categoryType}/${category.title.toLowerCase()}`);
    },
    prevPage () {
      if (this.currentPage > 0) {
        this.currentPage--;
      } else {
        this.currentPage = this.totalPages - 1;
      }
    },
    nextPage () {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
      } else {
        this.currentPage = 0;
      }
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.category-detail {
	background: #000;

	.categories-container {
		padding: rem(80) rem(180) rem(40);
		background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 1) 100%), linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
	}

	.categories-header {
		text-align: center;
		color: #fff;
		margin-bottom: rem(40);

		.categories-title {
			font-size: rem(52);
			font-weight: 900;
			line-height: rem(60);
		}

		.categories-subtitle {
			font-size: rem(20);
			line-height: rem(28);
		}
	}

	.categories-cards {
		display: flex;
		gap: rem(24);
		flex-wrap: wrap;

		.category-card {
			background: #000;
			border-radius: rem(16);
			padding: rem(24);
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: rem(20);
			min-width: calc(33.333% - rem(16));

			.card-header {
				display: flex;
				align-items: center;
				gap: rem(12);

				.card-dot {
					width: rem(8);
					height: rem(8);
					background: #fff;
					border-radius: 50%;
				}

				.card-title {
					color: #fff;
					font-size: rem(16);
					font-weight: 500;
				}
			}

			.card-items {
				display: flex;
				flex-direction: column;
				gap: rem(8);

				.card-item {
					border-radius: rem(16);
					padding: rem(18) rem(24);
					display: flex;
					justify-content: space-between;
					align-items: center;
					cursor: pointer;
					text-decoration: none;
					transition: all 0.3s ease;
					background: rgba(255, 255, 255, 0.1);

					&.colored-bg {
						&.active {
							background: linear-gradient(180deg, #c8ad17 0%, rgba(200, 173, 23, 0.2) 100%);
						}

						&:nth-child(1) {
							background: linear-gradient(180deg, #0088ff 0%, rgba(0, 136, 255, 0.2) 100%);
						}

						&:nth-child(2) {
							background: linear-gradient(180deg, #e54cba 0%, rgba(229, 76, 186, 0.2) 100%);
						}

						&:nth-child(3) {
							background: linear-gradient(180deg, #c8ad17 0%, rgba(200, 173, 23, 0.2) 100%);
						}
					}

					.item-text {
						color: #fff;
						font-size: rem(18);
						font-weight: 700;
					}

					.item-arrow {
						width: rem(6);
						height: rem(12);
						filter: brightness(0) invert(1);
					}

					&:hover {
						background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%) !important;
					}
				}
			}

			.card-footer {
				background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
				border-radius: rem(8);
				padding: rem(8) rem(16);
				display: flex;
				align-items: center;
				justify-content: center;
				gap: rem(8);
				cursor: pointer;
				width: rem(100);
				box-sizing: border-box;
				margin-top: auto;

				.view-all {
					color: #fff;
					font-size: rem(12);
					font-weight: 700;
				}

				.footer-arrow {
					width: rem(6);
					height: rem(10);
					filter: brightness(0) invert(1);
				}
			}
		}
	}

	.pagination-nav {
		margin-top: rem(24);
		display: flex;
		justify-content: center;
		align-items: center;

		.pagination-container {
			display: flex;
			align-items: center;
			gap: rem(16);
		}

		.pagination-arrow {
			width: rem(28);
			height: rem(28);
			border-radius: 50%;
			background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;

			img {
				width: rem(6);
				height: rem(12);
				filter: brightness(0) invert(1);
			}

			&.prev img {
				transform: rotate(180deg);
			}
		}

		.pagination-dots {
			display: flex;
			gap: rem(8);

			.pagination-dot {
				width: rem(8);
				height: rem(8);
				border-radius: 50%;
				background: rgba(255, 255, 255, 0.1);
				cursor: pointer;

				&.active {
					background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
				}
			}
		}
	}

	.combinations-section {
		padding: rem(40) rem(180) rem(80) rem(180);

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}

		.combinations-container {
			.combination-row {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: rem(24);
			}

			.combination-card-link {
				text-decoration: none;
				padding: rem(2);
				border-radius: rem(16);
				background: transparent;
				transition: all 0.3s ease;
				&:hover {
					background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
				}
			}

			.combination-card {
				background: rgb(26, 26, 26);
				border-radius: rem(14);
				padding: rem(24);
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: rem(172);
				box-sizing: border-box;
				cursor: pointer;

				.combination-text {
					color: #ffffff;
					font-size: rem(18);
					line-height: rem(24);
					font-weight: 700;
				}

				.see-more-button {
					background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
					border-radius: rem(8);
					padding: rem(8) rem(16);
					display: flex;
					align-items: center;
					justify-content: center;
					gap: rem(8);
					width: rem(100);
					height: rem(28);
					box-sizing: border-box;

					span {
						color: #ffffff;
						font-size: rem(12);
						font-weight: 700;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(10);
						filter: brightness(0) invert(1);
					}
				}
			}
		}
	}

	.search-sec-row {
		padding: 0 rem(180) rem(80);

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}
	}

	&.detect_deviece_mobile {
		.categories-container {
			padding: rem(40) rem(16);
		}

		.categories-header {
			.categories-title {
				font-size: rem(52);
				line-height: rem(60);
				margin-bottom: rem(16);
				text-align: left;
			}

			.categories-subtitle {
				font-size: rem(16);
				line-height: rem(24);
				text-align: left;
			}
		}

		.categories-cards {
			flex-direction: column;

			.category-card {
				min-width: 100%;
			}
		}

		.combinations-section {
			padding: rem(40) rem(16);
			.combinations-container .combination-row {
				display: flex;
				overflow-x: auto;
				gap: rem(16);
				padding: 0 rem(16);
				margin: 0 rem(-16);
				&::-webkit-scrollbar {
					display: none;
				}
				-ms-overflow-style: none;
				scrollbar-width: none;
			}
			.combination-card-link {
				flex-shrink: 0;
				width: rem(280);
			}
		}

		.search-sec-row {
			padding: 0 rem(16) rem(40);
		}
		.categories-cards .category-card .card-footer {
			width: 100%;
			border-radius: rem(12);
			padding: rem(16);

			.view-all {
				font-size: rem(14);
				font-style: normal;
				font-weight: 700;
				line-height: rem(14); /* 100% */
				text-transform: capitalize;
			}
		}
	}
}
</style> 